import { InputHTMLAttributes } from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../lib/utils';

export type CheckboxProps = InputHTMLAttributes<HTMLInputElement>;

/**
 * Themed checkbox: an emerald-filled box with a white tick, replacing the
 * browser-blue native control that clashes with the admin's accent. Keeps a
 * real <input type="checkbox"> underneath (role, aria-label, checked, onChange
 * all forwarded) so it stays accessible and behaves in forms and tests.
 */
export function Checkbox({ className, ...props }: CheckboxProps) {
  return (
    <span className="relative inline-flex h-4 w-4 shrink-0 items-center justify-center align-middle">
      <input
        type="checkbox"
        className={cn(
          'peer h-4 w-4 cursor-pointer appearance-none rounded border border-input bg-background shadow-sm transition-colors',
          'checked:border-primary checked:bg-primary',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      />
      <Check
        className="pointer-events-none absolute h-3 w-3 text-primary-foreground opacity-0 peer-checked:opacity-100"
        strokeWidth={3}
      />
    </span>
  );
}
